module.exports = __webpack_public_path__ + "public/images/fire.7e2533e4ad77564001872c0c142de611.png";